import { render } from "./SendFilesNimp.vue?vue&type=template&id=f846cc88&scoped=true"
import script from "./SendFilesNimp.vue?vue&type=script&lang=js"
export * from "./SendFilesNimp.vue?vue&type=script&lang=js"

import "./SendFilesNimp.vue?vue&type=style&index=0&id=f846cc88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f846cc88"]])

export default __exports__